import dayjs from "dayjs"
import { SellOutlined } from "@mui/icons-material"
import { Box, Grid, Typography } from "@mui/material"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { databaseDateToFilename } from "../Utilities"

export default function OverviewImage(props) {

    const { isSelected, isTagged, timestamp, index, onImageSelected, cameraUrl, archivePicture, fallbackSource } = props
    const { t } = useTranslation()

    const filename = databaseDateToFilename(archivePicture.datum)
    const [src, setSrc] = useState(`${cameraUrl + filename}`)

    function onErrorImgSrc() {
        if (src !== fallbackSource) {
            setSrc(fallbackSource)
        }
    }

    return (
        <Grid item xs={2} sm={4} md={4} key={`overview-grid-item-${index}`}>
            <Box
                id={`grid-image-${index}`}
                style={isSelected ? {
                    borderBottomLeftRadius: 6,
                    borderBottomRightRadius: 6,
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0,
                    backgroundColor: "#003366",
                    color: "white",
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingTop: 4,
                    overflowX: "hidden"
                } : {
                    width: '100%',
                    backgroundColor: 'white',
                    borderBottomLeftRadius: 6,
                    borderBottomRightRadius: 6,
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0,
                    overflowX: "hidden"
                }}
            >
                <img
                    onClick={() => onImageSelected(index, true)}
                    key={`grid-image-${index}`}
                    src={src}
                    alt={filename}
                    style={{
                        display: "flex",
                        width: "100%",
                        objectFit: "cover",
                        cursor: isSelected ? "default" : "pointer"
                    }}
                    loading="lazy"
                    onError={onErrorImgSrc}
                />

                <Typography
                    variant='body1'
                    align="center"
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        userSelect: "none"
                    }}
                >
                    {dayjs(timestamp).format(t("date.format.full_date_time"))}

                    {isTagged && (
                        <SellOutlined sx={{
                            fontSize: '15px',
                            pl: '4px'
                        }}/>

                    )}
                </Typography>
            </Box>
        </Grid >
    )
}
